import "./Cabinet.scss"
import MarginBox from '../../shared/components/other/MarginBox';
import NavBar from '../../shared/components/navbar/NavBar';
import Footer from '../../shared/components/other/Footer';
import CabHeader from './components/CabHeader';
import CabAbout from './components/CabAbout';
import CabStats from './components/CabStats';
import CabActivity from './components/CabActivity';
import EmptyProfileSection from './components/EmptyProfileSection';
import { useParams } from "react-router";
import Select from '../../shared/components/UI/Select';
import useGetUserProfile from "./hooks/useGetUserProfile";
import { AxiosError } from "axios";

const Cabinet = () => {
    const { guID } = useParams();
    let profileUsername = '';

    if (guID) {
        profileUsername = guID;
    } else {
        profileUsername = localStorage.getItem('username') || '';
    }

    const { data, isLoading, error } = useGetUserProfile(profileUsername, 'profile')

    const nullData: any = {
        "user_about": null,
        "team": null,
        "user_main_spec": null,
        "user_camouflages": [],
        "user_main_weapon": null,
        "user_banner_link": null
    }

    const profileBlocks = <>
        <CabHeader username={profileUsername} {...{ data, isLoading, error }}></CabHeader>
        <CabAbout {...{ data, isLoading, error }} username={profileUsername}></CabAbout>
        <CabActivity username={profileUsername}></CabActivity>
        <CabStats username={profileUsername}></CabStats>
    </>

    let content = profileBlocks

    let wrapperStyle = 'cabinet_bg'

    /*Наш профиль?*/
    const isOwnProfile = !guID || guID === localStorage.getItem('username')

    /*Профиль пустой? */
    const isEmptyProfile = () => {
        return Object.entries(nullData).every(
            ([key, value]) => JSON.stringify(data?.[key]) === JSON.stringify(value)
        )
    }

    /*Профиль скрыт*/
    if (error instanceof AxiosError && error.response?.status === 403) {
        content = <EmptyProfileSection isClosedProfile={true} />
        wrapperStyle = ""
    }

    /*Профиля не существует*/
    if (error instanceof AxiosError && error.response?.status === 404) {
        content = <EmptyProfileSection profileNotExists={true} />
        wrapperStyle = ""
    }

    /*Профиль пустой*/
    if (isOwnProfile && isEmptyProfile()) {
        content = <>
            <CabHeader username={profileUsername} {...{ data, isLoading, error }}></CabHeader>
            <EmptyProfileSection isClosedProfile={false} />
        </>
        wrapperStyle = ""
    }

    return (
        <MarginBox wrapperClassName={wrapperStyle}>
            <NavBar></NavBar>
            {content}
            <Footer></Footer>
        </MarginBox>
    );
}

export default Cabinet;
